import React, { useContext, useEffect, useState } from 'react';
import { StyleContext } from '../../providers/StyleContextProvider';
import { useMediaQuery } from 'react-responsive';

export const ScamAlertBanner: React.FC =()=> {
    const styleContext = useContext(StyleContext);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("scamAlertBanner"));

    useEffect(() => {        
            setStyles(styleContext.getComponentStyle("scamAlertBanner"));
        }, [isMobile]);
    
    return(
        <div style={styles}>
            <div style={styles.header}><span style={styles.boldText}>{"Notice of Scam Alert:"}</span><span>{" We have received reports of scammers falsely using the XpressJobs name on platforms such as "}</span><span style={styles.boldTextAndUnderline}>{"Telegram, WhatsApp, and Instagram."}</span> </div>
            <div style={styles.bodyMessage}>
               <span>{"Please be advised that"}</span><span style={styles.boldText}>{" XpressJobs does not request personal information or payments via messaging apps."}</span> 
            </div>
        </div>
    )
}